import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiBuildsResponseBody,
  IApiRunBuildsRequestBody,
} from '../BuildsApi.types';
import { useApi } from '~/lib/api/useApi';
import { onboardingStatusQueryKeyFactory } from '../../Onboarding/hooks/useOnboardingStatusQuery';
import { buildsQueryKeyFactory } from './useBuildsQuery';

export type IUseRunBuildsMutationValues = {
  appId: string;
  body?: IApiRunBuildsRequestBody;
};

export const useRunBuildsMutation = (): UseMutationResult<
  IApiBuildsResponseBody,
  unknown,
  IUseRunBuildsMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseRunBuildsMutationValues) =>
      api.builds.run(values.appId, values.body),
    onSuccess: async (_, variables) => {
      await queryClient.invalidateQueries({
        queryKey: buildsQueryKeyFactory({ appId: variables.appId }),
      });

      await queryClient.invalidateQueries({
        queryKey: onboardingStatusQueryKeyFactory({
          body: {
            target: 'application',
            id: variables.appId,
          },
        }),
      });
    },
  });
};
